module.exports = __webpack_public_path__ + "static/media/svg_avatar.3973cd6b.svg";